//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'InputLabel',

	props: {
		optional: {
			required: false,
			type: Boolean,
			default: false,
		},
	},
};
